export const projects = [
  {
    title: "Waysbucks",
    subtitle: "REACT & GOLANG",
    description:
      "Waysbucks is a web shop service which gives you access to sell beverage products",
    image: "./waysbucks.png",
    link: "https://rq-waysbucks.netlify.app",
  },
  {
    title: "Coways",
    subtitle: "REACT & GOLANG",
    description:
      "Coways is a music web service that gives you access to millions of songs and easy to use.",
    image: "./coways.png",
    link: "https://coways.netlify.app",
  },
];

export const skills = [
  {
    technologies: "HTML",
  },
  {
    technologies: "CSS",
  },
  {
    technologies: "JavaScript",
  },
  {
    technologies: "Golang",
  },
  {
    technologies: "React JS",
  },
  {
    technologies: "Bootstrap",
  },
  {
    technologies: "Tailwind CSS",
  },
  {
    technologies: "GIT",
  },
];
